export default {
  'zh-CN': {
    myCustomerService: '我的客服',
    viewDetails: '查看详细内容',
    helpCenter: '帮助中心',
    supposeYouWantToAsk: '猜你想问',
    pleaseDescribeTheProblemYouEncountered: '请描述您遇到的问题',
    send: '发送',
    CanFindTheAnswerGoToThe: '找不到答案？去',
    seeMoreAnswers: '查看更多解答',
    youCanAlsoAskAnotherQuestionToTryOrTo: '您也可以换个问法试试，或者到',
    queryMore: '查询更多',
    pressEnterToSend: '按Enter发送',
    pressCtrlEnterToSend: '按Ctrl+Enter发送'
  },
  'en': {
    myCustomerService: '我的客服',
    viewDetails: '查看详细内容',
    helpCenter: 'Help Center',
    supposeYouWantToAsk: '猜你想问',
    pleaseDescribeTheProblemYouEncountered: '请描述您遇到的问题',
    send: 'Send',
    CanFindTheAnswerGoToThe: '找不到答案？去',
    seeMoreAnswers: '查看更多解答',
    youCanAlsoAskAnotherQuestionToTryOrTo: '您也可以换个问法试试，或者到',
    queryMore: '查询更多',
    pressEnterToSend: '按Enter发送',
    pressCtrlEnterToSend: '按Ctrl+Enter发送'
  },
  'ja': {
    myCustomerService: '我的客服_ja',
    viewDetails: '查看详细内容_ja',
    helpCenter: '帮助中心_ja',
    supposeYouWantToAsk: '猜你想问_ja',
    pleaseDescribeTheProblemYouEncountered: '请描述您遇到的问题_ja',
    send: '发送_ja',
    CanFindTheAnswerGoToThe: '找不到答案？去_ja',
    seeMoreAnswers: '查看更多解答_ja',
    youCanAlsoAskAnotherQuestionToTryOrTo: '您也可以换个问法试试，或者到_ja',
    queryMore: '查询更多_ja',
    pressEnterToSend: '按Enter发送_ja',
    pressCtrlEnterToSend: '按Ctrl+Enter发送_ja'
  }
}
